var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"latexDiv",domProps:{"innerHTML":_vm._s('$$'+_vm.latex+'$$')}})
}
var staticRenderFns = []

export { render, staticRenderFns }